/**
 * Get the value of a query parameter by name from a stringified URL
 * @param {string} string stringified URL
 * @param {name} string name of the parameter
 * @returns {string}
 */
const getQueryParamFromString = (string, name) => {
    const href = new URL(string);
    return href.searchParams.get(name);
};
export default getQueryParamFromString;
